/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {AbstractControl} from '@angular/forms';


export const ALWAYS = 'always';
export const NO = 'no';
export const SUBMITTED = 'submitted';
export const TOUCHED = 'touched';
export const TOUCHED_OR_SUBMITTED = 'touched_submitted';


export function hasValidation(showValidation: string): boolean {
  return showValidation.toLowerCase() !== NO;
}

export function isControlValid(control: AbstractControl, showValidation: string): boolean {
  return control && !control.invalid && hasValidation(showValidation);
}

export function isControlInvalid(control: AbstractControl, showValidation: string, submitted: boolean): boolean {
  const isInvalid = control && control.invalid;

  switch (showValidation.toLowerCase()) {
    case NO:
      return false;
    case TOUCHED:
      return isInvalid && (control.touched || control.dirty);
    case SUBMITTED:
      return isInvalid && submitted;
    case TOUCHED_OR_SUBMITTED:
      return isInvalid && (control.touched || control.dirty || submitted);
    case ALWAYS:
    default:
      return isInvalid;
  }
}
